import axios from '@/plugins/axios'

const state = {
    countries: []
}

// getters
const getters = {
    getCountries(state) {
        return state.countries
    },

    getCountryByISO(state) {
        return (iso) => {
            return state.countries.find(c => c.iso === iso)
        }
    },
}

// actions
const actions = {
    async loadCountries({ commit }) {
        commit('addToLoadingQueue', 'load_countries',  { root: true });

        return axios.get('/country')
          .then((response) => {
              commit('setCountries', response.data );
                        commit('removeFromLoadingQueue', 'load_countries',  { root: true });
          })
          .catch((error) => {
              commit('removeFromLoadingQueue', 'load_countries',  { root: true });
              commit('error/newError', {
                  title: 'error.country.load',
                  text: error.response? error.response.data.message || error.message: error.message
              }, { root: true});
          });
    }
}

// mutations
const mutations = {
    setCountries(state, countries) {
        state.countries = countries
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
